import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useDisplayTemplatesPageStyles = makeStyles({
  displayTemplatePage: {
    display: 'flex',
    ...shorthands.margin('32px', '36px'),
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
});
